const preventScrollTop = (to={}, from={}) => {
  return (to.name && 
    (((to.name.startsWith('DiningSearchAllRestaurant')
        || to.name.startsWith('TravelAgencySearch'))
        && (to.query.id || from.query.id)
      )
    )
  )
} 

export default (to, from, savedPosition) => {
  if (to.hash) {
    return { selector: to.hash, offset: { x: 0, y: 50 } }
  }
  if (preventScrollTop(to, from)) {
    return false;
  } ;
  return savedPosition ? savedPosition : { y: 0 }
}